@if (otpForm) {
  <div class="form-container" [formGroup]="otpForm">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Menu Header </label>
          </div>
          <clickatell-form-validation [controlName]="'text'"
          [form]="otpForm"></clickatell-form-validation>
          <textarea class="control-textArea" activeForm [activeForm]="otpForm" id="text"
          [formControlName]="'text'" placeholder="Enter header"></textarea>
        </div>
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Retries </label>
          </div>
          <clickatell-form-validation [controlName]="'retries'"
          [form]="otpForm"></clickatell-form-validation>
          <input type="number" class="control-input" activeForm [activeForm]="otpForm" id="retries"
            [formControlName]="'retries'" />
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Resends </label>
            </div>
            <clickatell-form-validation [controlName]="'resends'"
            [form]="otpForm"></clickatell-form-validation>
            <input type="number" class="control-input" activeForm [activeForm]="otpForm" id="resends"
              [formControlName]="'resends'" />
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Otp Length </label>
              </div>
              <clickatell-form-validation [controlName]="'otpLength'"
              [form]="otpForm"></clickatell-form-validation>
              <input type="number" class="control-input" activeForm [activeForm]="otpForm" id="otpLength"
                [formControlName]="'otpLength'" />
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Time Out </label>
                </div>
                <clickatell-form-validation [controlName]="'otpTimetolive'"
                [form]="otpForm"></clickatell-form-validation>
                <input type="number" class="control-input" activeForm [activeForm]="otpForm" id="otpTimetolive"
                  [formControlName]="'otpTimetolive'" />
                </div>
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Resend Inputs </label>
                  </div>
                  <clickatell-form-validation [controlName]="'resendInput'"
                  [form]="otpForm"></clickatell-form-validation>
                  <clickatell-chip [name]="'resendInput'" [field]="KEYWORD_FIELD" [form]="otpForm" [minLength]="null">
                  </clickatell-chip>
                </div>
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Otp Message Text </label>
                  </div>
                  <clickatell-form-validation [controlName]="'otpMessageText'"
                  [form]="otpForm"></clickatell-form-validation>
                  <input class="control-input" activeForm [activeForm]="otpForm" id="otpMessageText"
                    [formControlName]="'otpMessageText'" />
                  </div>
                  <div class="control-div">
                    <div class="control-label-container">
                      <label class="control-label"> Resend Limit Reached Message </label>
                    </div>
                    <clickatell-form-validation [controlName]="'resendLimitReachedMessage'"
                    [form]="otpForm"></clickatell-form-validation>
                    <input class="control-input" activeForm [activeForm]="otpForm" id="resendLimitReachedMessage"
                      [formControlName]="'resendLimitReachedMessage'" />
                    </div>
                    <div class="control-div">
                      <div class="control-label-container">
                        <label class="control-label"> Retry Text To Prepend </label>
                      </div>
                      <clickatell-form-validation [controlName]="'retryText'"
                      [form]="otpForm"></clickatell-form-validation>
                      <input class="control-input" activeForm [activeForm]="otpForm" id="retryText"
                        [formControlName]="'retryText'" />
                      </div>
                      <div class="control-div">
                        <div class="control-label-container">
                          <label class="control-label"> Resend Text To Prepend </label>
                        </div>
                        <clickatell-form-validation [controlName]="'resendText'"
                        [form]="otpForm"></clickatell-form-validation>
                        <input class="control-input" activeForm [activeForm]="otpForm" id="resendText"
                          [formControlName]="'resendText'" />
                        </div>
                      </ng-container>
                    </clickatell-expansion-panel>
                    <clickatell-expansion-panel>
                      <ng-container header>
                        <mat-panel-title>
                          Logic
                        </mat-panel-title>
                      </ng-container>
                      <ng-container body>
                        <div class="control-result">
                          <div class="control-result-header">
                            Success
                          </div>
                          <div class="control-result-container">
                            <div class="control-div">
                              <div class="control-label-container">
                                <label class="control-label"> Description </label>
                              </div>
                              <clickatell-form-validation [controlName]="'successDescription'"
                              [form]="otpForm"></clickatell-form-validation>
                              <input class="control-input" activeForm [activeForm]="otpForm" id="successDescription"
                                [formControlName]="'successDescription'" />
                              </div>
                              <div class="control-div">
                                <label class="control-label">
                                  <span class="pont-to">Point To</span>
                                  <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                                </label>
                                @if (nodeFlowDetails) {
                                  <next-selector [canEditFlows]="canEdit.canEditFlows"
                                    [selectorType]="'both'"
                                    [flowSteps]="nodeFlowDetails.currentFlowSteps"
                                    [flows]="nodeFlowDetails.flows"
                                    [name]="'successNext'"
                                    [form]="otpForm"
                                    [stepId]="nodeFlowDetails.stepId">
                                  </next-selector>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="control-result">
                            <div class="control-result-header">
                              Failure
                            </div>
                            <div class="control-result-container">
                              <div class="control-div">
                                <div class="control-label-container">
                                  <label class="control-label"> Description </label>
                                </div>
                                <clickatell-form-validation [controlName]="'failureDescription'"
                                [form]="otpForm"></clickatell-form-validation>
                                <input class="control-input" activeForm [activeForm]="otpForm" id="failureDescription"
                                  [formControlName]="'failureDescription'" />
                                </div>
                                <div class="control-div">
                                  <label class="control-label">
                                    <span class="pont-to">Point To</span>
                                    <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                                  </label>
                                  @if (nodeFlowDetails) {
                                    <next-selector [canEditFlows]="canEdit.canEditFlows"
                                      [selectorType]="'both'"
                                      [flowSteps]="nodeFlowDetails.currentFlowSteps"
                                      [flows]="nodeFlowDetails.flows"
                                      [name]="'failureNext'"
                                      [form]="otpForm"
                                      [stepId]="nodeFlowDetails.stepId">
                                    </next-selector>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="control-result">
                              <div class="control-result-header">
                                Error
                              </div>
                              <div class="control-result-container">
                                <div class="control-div">
                                  <div class="control-label-container">
                                    <label class="control-label"> Description </label>
                                  </div>
                                  <clickatell-form-validation [controlName]="'errorDescription'"
                                  [form]="otpForm"></clickatell-form-validation>
                                  <input class="control-input" activeForm [activeForm]="otpForm" id="errorDescription"
                                    [formControlName]="'errorDescription'" />
                                  </div>
                                  <div class="control-div">
                                    <label class="control-label">
                                      <span class="pont-to">Point To</span>
                                      <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                                    </label>
                                    @if (nodeFlowDetails) {
                                      <next-selector [canEditFlows]="canEdit.canEditFlows"
                                        [selectorType]="'both'"
                                        [flowSteps]="nodeFlowDetails.currentFlowSteps"
                                        [flows]="nodeFlowDetails.flows"
                                        [name]="'errorNext'"
                                        [form]="otpForm"
                                        [stepId]="nodeFlowDetails.stepId">
                                      </next-selector>
                                    }
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </clickatell-expansion-panel>
                        </div>
                      }